import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSlotModule } from '@spartacus/storefront';
import { ConfigModule, I18nModule, provideDefaultConfig } from '@spartacus/core';
import { PrimengModule } from '../primeng/primeng.module';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpBackend } from '@angular/common/http';

import { customDefaultOccProductConfig } from './config/default-occ-product-config';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CUSTOM_PRODUCT_FEATURE } from './store/custom-product-list.state';
import { effects } from './store/effects';
import { customProductListReducer } from './store/reducers/custom-product-list.reducer';
import { CustomProductListEffectsService } from './store/effects/custom-product-list-effect.service';

import { CategoryToggleFilterPipe } from './pipes/category-toggle-filter.pipe';

import { ProductGridComponent } from './components/product-grid/product-grid.component';
import { ProductFilterComponent } from './components/product-filter/product-filter.component';

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}

@NgModule({
  declarations: [
    CategoryToggleFilterPipe,
    ProductFilterComponent,
    ProductGridComponent,
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    PrimengModule,
    SGRESharedModule,
    StoreModule.forFeature(CUSTOM_PRODUCT_FEATURE, customProductListReducer),
    EffectsModule.forFeature(effects),
    ConfigModule.withConfig({
      cmsComponents: {
        ProductRefinementComponent: {
          component: () => import('./components/product-filter/product-filter.component').then(m => m.ProductFilterComponent),
        },
        ProductGridComponent: {
          component: () => import('./components/product-grid/product-grid.component').then(m => m.ProductGridComponent),
        }
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule,
  ],
  providers: [
    TranslateService,
    { provide: TranslateStore },
    provideDefaultConfig(customDefaultOccProductConfig),
    CustomProductListEffectsService,
  ]
})
export class ProductListPageModule { }